"use client";
import styles from "./vocal-remover-page.module.scss";
import VocalRemoveButton from "@/components/pages/vocal-remover/components/vocal-remove-button";
import VocalRemoverGenerating from "@/components/pages/vocal-remover/components/vocal-remover-generating";
import VocalRemoverResult from "@/components/pages/vocal-remover/components/vocal-remover-result";
import VocalRemoverStepsToIsolate from "@/components/pages/vocal-remover/components/vocal-remover-steps-to-isolate/vocal-remover-steps-to-isolate";
import VocalRemoverTopApplications from "@/components/pages/vocal-remover/components/vocal-remover-top-applications/vocal-remover-top-applications";
import VocalRemoverAdvantages from "@/components/pages/vocal-remover/components/vocal-remover-advantages/vocal-remover-advantages";
import { useVocalRemoverProgressContext } from "@/components/pages/vocal-remover/providers/vocal-remover-progress-provider";
import ServicePageHeader from "@/components/common/service-page-header";
import MediaFormatsInput from "@/components/common/input/media-formats-input";
import { useCreateProcessInputsHandler } from "@/hooks/ai-tool-process/use-create-process-inputs-handler";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import VocalRemoveTutorialButton from "@/components/pages/vocal-remover/components/vocal-remove-tutorial-button";
import React from "react";
import { useMobile } from "@/hooks/use-responsive";
import {
  shouldDisplayProgress,
  shouldDisplayStartProcessButton,
} from "@/hooks/progress-context/use-anonymous-progress-provider";

const VocalRemoverPage = () => {
  const { license } = useProfileContext();
  const progressContext = useVocalRemoverProgressContext();
  const { songFile } = useCreateProcessInputsHandler();
  const { isMobile } = useMobile();

  const mediaContent = (
    <div className={styles.media_input_wrapper}>
      <ServicePageHeader
        title={
          <>
            Vocal <span>Remover</span>
          </>
        }
        description={
          "AudioModify Vocal Remover is a versatile tool designed for isolating and cleaning vocals. It allows you to separate vocals from instrumentals, all in a single platform."
        }
      />
      {shouldDisplayStartProcessButton(progressContext.status) &&
        progressContext.status !== "complete" && (
          <>
            <div className={styles.media_wrapper}>
              <MediaFormatsInput
                localFileInputProps={{ isLimited: false, license: license }}
              />
            </div>
            <VocalRemoveButton songFile={songFile} />
          </>
        )}

      {shouldDisplayProgress(progressContext.status) && (
        <div className={styles.media_wrapper}>
          <VocalRemoverGenerating percent={progressContext.percent} />
        </div>
      )}
      {progressContext.status === "complete" && songFile && (
        <div className={styles.media_wrapper}>
          <VocalRemoverResult
            id={progressContext.processId}
            vocalUrl={progressContext.vocalFileUrl}
            instrumentalUrl={progressContext.instrumentalFileUrl}
            originalFile={songFile}
            setStatus={() => progressContext.setStatus("")}
          />
        </div>
      )}
    </div>
  );

  return (
    <div className={styles.vocal_remover_page}>
      <div className={styles.header_wrapper}>{mediaContent}</div>
      <VocalRemoverStepsToIsolate />
      <VocalRemoverTopApplications />
      <VocalRemoverAdvantages />
    </div>
  );
};

export default VocalRemoverPage;
